import { useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from './constants';

export const useIsWebView = () => {
    const queryClient = useQueryClient();

    if (process.env.IS_NEXT !== 'true') {
        return false;
    }

    const isWebView = queryClient.getQueryData<boolean>([QUERY_KEYS.IS_WEB_VIEW]);

    return isWebView;
};
